<div class="d-flex flex-row">
  <div class="arrow" (click)="goDown()">
    <img src="./assets/ui/svg/grey/arrow-left.svg">
  </div>
  <div class="indicator">
    <span>{{pageStatus.currentPage}} / {{pageStatus.allItems | lastPage : pageStatus.itemsPerPage}}</span>
  </div>
  <div class="arrow" (click)="goUp()">
    <img src="./assets/ui/svg/grey/arrow-right.svg">
  </div>
</div>
